import { Injectable, inject } from '@angular/core';
import { FeedbackAttachmentDraft } from '../types/feedback-attachment-draft';
import { TechnicalDiagnosticsOrchestratorService } from './internal/technical-diagnostics-orchestrator.service';

@Injectable({
  providedIn: 'root',
})
export class TechnicalDiagnosticsService {
  private readonly orchestrator = inject(TechnicalDiagnosticsOrchestratorService);

  startCapture(): void {
    this.orchestrator.start();
  }

  stopCapture(): void {
    this.orchestrator.stop();
  }

  clearCapture(): void {
    this.orchestrator.clear();
  }

  createAttachment(): FeedbackAttachmentDraft {
    const diagnostics = this.orchestrator.snapshot();
    const payload = JSON.stringify(diagnostics, null, 2);
    const file = new File([payload], 'technical-diagnostics.json', { type: 'application/json' });

    return {
      id: `diagnostics-${Date.now()}`,
      file,
      uploadStatus: 'pending',
      uploadError: null,
      isDiagnostics: true,
    };
  }
}
